import moment from "moment";

function ExportProjectDashboardFileFormatter(projectName) {
  return `${projectName}-${moment(new Date()).format("YYYY_MM_DD")}`;
}

export default ExportProjectDashboardFileFormatter;
